import axiosInstance from "../config/axiosConfig";
import useConfigStore from "../store/configStore";
import type { UserAuthApiResponse } from "../types/user";

export const login_with_otp = async (payload: {
  user_email: string;
  user_otp: string;
}) => {
  const endpoint = useConfigStore.getState().getEndpoint('loginWithOtp');
  const { data } = await axiosInstance.post(
    endpoint,
    payload,
    // {
    //   withCredentials: true, // Ensure credentials are included
    // }
  );
  return data;
};

export const send_otp = async (payload: { user_email: string }) => {
  const endpoint = useConfigStore.getState().getEndpoint('sendOtp');
  const { data } = await axiosInstance.post(endpoint, payload, 
  //   {
  //   withCredentials: true, // Ensure credentials are included
  // }
);
  return data;
};

export const logout = async () => {
  const refreshToken = localStorage.getItem("refreshToken");
  const endpoint = useConfigStore.getState().getEndpoint('logout');
  await axiosInstance.post(
    endpoint,
    {
      refreshToken,
    },
    // {
    //   withCredentials: true, // Ensures that cookies are sent with the request
    // }
  );
};

export const getAuthStatus = async (): Promise<UserAuthApiResponse> => {
  const endpoint = useConfigStore.getState().getEndpoint('authStatus');
  const { data } = await axiosInstance.get(endpoint);
  return data;
};
